import {
  Principal_Read_Nested,
  SettlementExport_Read,
  SettlementExport_Read_Nested,
  SettlementExportRendererKey,
  SettlementExportStatus,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from '~types/Nullable';

export class SettlementExportBasic {
  constructor(
    private _id: string,
    private _renderer_key: SettlementExportRendererKey,
    private _renderer_version: Nullable<string>,
    private _status: SettlementExportStatus,
    private _completed_at: Nullable<Dayjs>,
    private _requested_by: Nullable<Principal_Read_Nested>,
  ) {}

  public static parse(proto: SettlementExport_Read_Nested) {
    return new SettlementExportBasic(
      proto.id,
      proto.renderer_key,
      proto.renderer_version,
      proto.status,
      proto.completed_at ? dayjs(proto.completed_at) : null,
      proto.requested_by ?? null,
    );
  }

  public get id() {
    return this._id;
  }

  public get rendererKey() {
    return this._renderer_key;
  }

  public get rendererVersion() {
    return this._renderer_version;
  }

  public get status() {
    return this._status;
  }

  public get completedAt() {
    return this._completed_at;
  }

  public get requestedBy() {
    return this._requested_by;
  }
}

export class SettlementExport {
  constructor(
    private _id: string,
    private _renderer_key: SettlementExportRendererKey,
    private _status: SettlementExportStatus,
    private _failure_reason: Nullable<string>,
    private _file_url: Nullable<string>,
  ) {}

  public static parse(proto: SettlementExport_Read) {
    return new SettlementExport(
      proto.id,
      proto.renderer_key,
      proto.status,
      proto.failure_reason,
      proto.file_url ?? null,
    );
  }

  public get id() {
    return this._id;
  }

  public get rendererKey() {
    return this._renderer_key;
  }

  public get status() {
    return this._status;
  }

  public get failureReason() {
    return this._failure_reason;
  }

  public get fileUrl() {
    return this._file_url;
  }
}
